import httpService from 'services/HttpService';
import { generateURLRappiServices } from 'shared/utils/urls';

import { ORDER_DETAIL_API_PATH } from './orderDetail.const';

import type { OrderId } from 'shared/domain';
import type { OrderDetailRawResp } from 'shared/infra';

export function readOrderDetailById(orderId: OrderId) {
  return httpService.get<OrderDetailRawResp>(
    generateURLRappiServices({
      url: ORDER_DETAIL_API_PATH.READ_ORDER_DETAIL_BY_ID,
      pathParams: { orderId },
    }),
  );
}

export const orderDetailRepository = {
  readOrderDetailById,
};
